import { useFormContext } from "react-hook-form";

import { MongoDBSecretField } from "src/connections/config/database/mongodb/MongoDBSecretField";
import { ConfigFieldsetCard as FieldsetCard } from "src/connections/config/FieldsetCard";
import { isFieldErrored } from "src/connections/config/isFieldErrored";
import {
  Environment,
  MongoDBConnectionConfigInputs,
} from "src/connections/types";

type Props = {
  environment: Environment;
};

export const MongoDBUsernamePasswordAuthFieldset: React.FC<Props> = ({
  environment,
}) => {
  const {
    formState: { errors },
  } = useFormContext<MongoDBConnectionConfigInputs>();
  const envErrors =
    errors?.[`${environment}Config`]?.["usernamePasswordConfig"];

  return (
    <FieldsetCard className="last:mb-0">
      <MongoDBSecretField
        environment={environment}
        helpText="The username of the MongoDB database user"
        isErrored={isFieldErrored(envErrors, "username")}
        secretConfigField="usernamePasswordConfig.username"
        secretName="Username"
        isRequired
      />
      <MongoDBSecretField
        environment={environment}
        helpText="The password of the MongoDB database user"
        isErrored={isFieldErrored(envErrors, "password")}
        secretConfigField="usernamePasswordConfig.password"
        secretName="Password"
        isRequired
      />
    </FieldsetCard>
  );
};
